import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DynamicTitle from '../components/DynamicTitle';
import CurvedLoop from '../components/CurvedLoop/CurvedLoop';
import './Landing.css';

const Landing: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [curveAmount, setCurveAmount] = useState(300);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);



  // Define different signature styles to choose from
  return (
    <div className="landing">
      <div className="landing-content">
        {!isMobile && (
          <div className="landing-left">
            <DynamicTitle/>
          </div>
        )}
        {isMobile && (
          <div className="mobile-curved-loop">
            <CurvedLoop 
              marqueeText="• Gidi Rubin • Developer, Designer, Engineer"
              speed={2}
              curveAmount={300}
              direction="left"
              interactive={false}
              className="mobile-curved-text"
            />
          </div>
        )}
        <div className="landing-right">
          <Link to="/projects" className="btn btn-projects">Projects</Link>
          <Link to="/about" className="btn btn-about">About</Link>
        </div>
      </div>
    </div>
  );
};

export default Landing;
